var map = {
	"./euro2024.webp": 1509,
	"./euro2024_title.svg": 1510,
	"./event-sport-bg.jpg": 1511,
	"./event-sport-bg.png": 1512,
	"./home-icon-active.webp": 1513,
	"./home-icon.webp": 1514,
	"./img_bg-uefa.png": 1515,
	"./live-icon-active.webp": 1516,
	"./master-bg.webp": 1517,
	"./me-icon-active.webp": 1518,
	"./product-overview-bg.webp": 1519,
	"./promos-icon-active.webp": 1520,
	"./sponsor-icon-active.webp": 1521,
	"./uefa-icon-active.webp": 1522,
	"./uefa-icon.webp": 1523,
	"./uefa-prediction.webp": 1524,
	"./wwr-img.webp": 1525
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 209;